<template>
  <template v-if="entries">
    <template v-for="(entry, i) in entries.filter(e => e.count != null)" :key="i">
      <router-link v-if="entry.link" :to="entry.link" class="connectorBadgePill connectorBadgePill--link">
        <AppIcon :name="entry.icon" :size="13" />
        {{ entry.count }}
      </router-link>
      <span v-else class="connectorBadgePill">
        <AppIcon :name="entry.icon" :size="13" />
        {{ entry.count }}
      </span>
    </template>
  </template>
  <template v-else>
    <router-link v-if="count != null && to" :to="to" class="connectorBadgePill connectorBadgePill--link">{{ count }}</router-link>
    <span v-else-if="count != null" class="connectorBadgePill">{{ count }}</span>
  </template>
</template>

<script setup lang="ts">
import AppIcon from '../../../components/AppIcon.vue'

defineProps<{
  count?: number | null
  to?: string
  entries?: { icon: 'account' | 'contact'; count: number | null; link?: string }[]
}>()
</script>

<style scoped>
.connectorBadgePill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  min-width: 36px;
  height: 28px;
  padding: 0 var(--space-3);
  border-radius: var(--radius-full);
  background: var(--color-bg-surface);
  border: 1px solid var(--color-border-strong);
  font-family: var(--font-sans);
  font-size: var(--fs-base);
  font-weight: var(--fw-semibold);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-neu-out-cream-sm);
}

.connectorBadgePill--link {
  text-decoration: none;
  cursor: pointer;
  transition: border-color var(--duration-fast) var(--ease-out),
              box-shadow var(--duration-fast) var(--ease-out);
}
.connectorBadgePill--link:hover {
  border-color: var(--color-accent);
  box-shadow: var(--shadow-neu-out-cream);
}
</style>
